import { Container, Distribute } from '@loomhq/lens';
import PropTypes from 'prop-types';
import React from 'react';

const RIGHT_PANEL_EXTRA_HEIGHT = 10;
const CONTROL_BAR_OFFSET = 32;

const SharePageCard = props => {
  const { height, children, header, onRightPanel } = props;

  function componentHeight() {
    let calculatedHeight = height;

    if (onRightPanel) {
      calculatedHeight -= RIGHT_PANEL_EXTRA_HEIGHT + CONTROL_BAR_OFFSET;
    }

    return calculatedHeight;
  }

  return (
    <Distribute direction="column">
      <Container borderSide="all" width="100%" radius="medium">
        {header}
        <Container borderSide="top" height={`${componentHeight()}px` || 'auto'}>
          {children}
        </Container>
      </Container>
    </Distribute>
  );
};

SharePageCard.propTypes = {
  height: PropTypes.number,
  onRightPanel: PropTypes.bool,
  header: PropTypes.element,
  children: PropTypes.element,
};

export default SharePageCard;
